/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {ReferenceDataContract} from '../../api/contracts/reference-data.contract';
import {ReferenceDataModel} from './reference-data.model';


export class ReferenceDataMapper {
    static fromReferenceDataContractArray(input: ReferenceDataContract[]): ReferenceDataModel[] {
        return input?.map((element) => ReferenceDataMapper.fromReferenceDataContract(element));
    }

    static fromReferenceDataContract(input: ReferenceDataContract): ReferenceDataModel {
        let model: ReferenceDataModel;

        if (input != null) {
            model = {
                code: input.code,
                name: input.name,
                active: input.active
            };
        }
        return model;
    }
}
